import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function ServiceCard({ service }) {
  const Icon = service.icon;
  return (
    <Link
      to={`/services/${service.slug}`}
      data-testid={`service-card-${service.slug}`}
      className="group flex h-full flex-col rounded-xl border border-slate-200 bg-white p-6 shadow-sm transition-[transform,box-shadow,border-color] duration-300 ease-out hover:-translate-y-1 hover:border-blue-200 hover:shadow-md"
    >
      <div className="flex items-center justify-between">
        <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-blue-50 text-blue-900">
          <Icon className="h-5 w-5" aria-hidden="true" />
        </span>
        {service.fee > 0 ? (
          <span className="rounded-full bg-amber-50 px-3 py-1 font-mono text-[11px] font-medium text-amber-700">
            ₹{service.fee} fee
          </span>
        ) : (
          <span className="rounded-full bg-green-50 px-3 py-1 font-mono text-[11px] font-medium text-green-700">
            Free
          </span>
        )}
      </div>
      <h3 className="mt-5 font-display text-lg font-bold tracking-tight text-slate-900">
        {service.title}
      </h3>
      <p className="mt-2 flex-1 text-sm leading-relaxed text-slate-600">{service.tagline}</p>
      <span className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-blue-900">
        View details
        <ArrowRight
          className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1"
          aria-hidden="true"
        />
      </span>
    </Link>
  );
}
